<template>
  <div class="list-fliter-wrap pd-top15 f-pr pd-left10">
    <!--新增按钮-->
    <div v-if="isAddBtn" class="add-item-btn f-pa f-df f-ai f-fs14 color-blue f-csp mg-top10" @click="addBtn">
      <i class="el-icon-plus mg-right5 f-fs14 f-fwb"></i>
      <span>{{ addBtnTxt || '新增' }}</span>
    </div>
    <div v-if="isShowChooseFilter && chooseFilterArr.length" class="selete-filter-item-box f-df">
      <label class="min-wid80 f-cl3 mg-top5">已选条件</label>
      <div
        v-for="(item, index) in chooseFilterArr"
        :key="index"
        class="f-df f-fww f-ai">
        <span class="f-csp selected-item bor-blue color-blue mg-left15">
          <em class="f-fwn mg-right5">{{ item.label + '：'}}{{ item.value }}</em>
          <i class="el-icon-close blue-color f-fs2" @click="deleteFilter(item.id, item.key)"></i>
        </span>
      </div>
    </div>
    <!--表单选择-->
    <div
      class="list-fliter-main-con"
      :class="'form-' + formItemPosition">
      <el-form
        ref="ruleForm"
        :model="bindForms"
        :rules="ruleForm"
        :status-icon="!!ruleForm.pass"
        :label-position="lablePosition"
        :label-width="labelWidth"
        class="list-filter-form">
        <el-form-item
          v-for="(item, index) in formArr"
          v-show="!item.isHide && (isExpand || !index)"
          :key="item.id"
          :label="item.label"
          :prop="item.id"
          :class="'form-item-' + item.type + ' form-item-' + item.id + '-box' + (!item.label ? ' form-item-no-label' : '')"
          :style="{width: item.width ? item.width : 'auto'}">
          <p v-if="item.type === 'text'">{{ bindForms[item.id] }}</p>
          <div
            v-else-if="item.type === 'tab'"
            class="tab-group">
            <ul class="bor-gray f-df f-ai">
              <li
                v-for="(elem, i) in item.children"
                :key="i"
                :class="elem.id === bindForms[item.id] ? 'bg-blue color-white' : ''"
                class="tab-group-item f-csp"
                @click="tabGropChange(item, elem)">
                {{ elem.name }}
              </li>
            </ul>
          </div>
          <!--下拉-->
          <el-select
            v-else-if="item.type === 'select'"
            v-model="bindForms[item.id]"
            :clearable="!item.clearable"
            :multiple="!!item.multiple"
            :collapse-tags="!!item.collapseTags"
            :placeholder="item.placeholder || '请选择'"
            @change="formChange($event, item)">
            <el-option
              v-for="(elem, i) in item.children"
              :key="i"
              :label="elem.name"
              :value="elem.id" />
          </el-select>
          <el-radio-group
            v-else-if="item.type === 'radio'"
            v-model="bindForms[item.id]"
            class="radio-item-group"
            @change="formChange($event, item)">
            <el-radio
              v-for="elem in item.children"
              :key="elem.id"
              :label="elem.id">
              {{ elem.name }}
            </el-radio>
          </el-radio-group>
          <!-- 多选 -->
          <el-checkbox-group
            v-else-if="item.type === 'checkbox'"
            v-model="bindForms[item.id]"
            class="checkbox-item-group"
            @change="formChange($event, item)">
            <el-checkbox
              v-for="elem in item.children"
              :label="elem.id"
              :key="elem.id">
              {{ elem.name }}
            </el-checkbox>
          </el-checkbox-group>
          <!-- radio 自定义时间 -->
          <div v-else-if="item.type === 'radioDate'" class="radio-date-define-box f-df f-ai f-fww">
            <el-radio-group
              v-model="bindForms[item.id]"
              class="radio-item-group"
              @change="formChange($event, item)">
              <el-radio
                v-for="elem in item.children"
                :key="elem.id"
                :label="elem.id">
                <span @click="dateDefineChoose(item, elem)">
                  {{ elem.name }}
                </span>
              </el-radio>
            </el-radio-group>
            <div v-show="item.isShowChooseDate" class="radio-date-range f-df f-ai mg-left15" @click.stop="">
              <el-date-picker
                v-model="item.defineDateVal"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                width="450px"
                @change="defineDateEnsure($event, item)" />
              <!-- <span class="f-csp white-bg color-blue bor-blue mg-left15 ensure-date-btn" @click.stop="defineDateEnsure(item.defineDateVal, item)">确定</span>
              <span class="f-csp f-cl9 mg-left10 cancle-date-btn" @click.stop="defineDateCancle(item)">取消</span> -->
            </div>
          </div>
          <!-- 日期选择 -->
          <el-date-picker
            v-else-if="item.type === 'date' || item.type === 'year' || item.type === 'month' || item.type === 'week' || item.type === 'dates'"
            v-model="bindForms[item.id]"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :format="item.format || 'yyyy年 MM月 dd日'"
            :value-format="item.valueFormat || 'yyyy-MM-dd'"
            :type="item.type"
            :clearable="!item.clearable"
            @change="formChange($event, item)" />
          <div v-else-if="item.type === 'datesRange'" class="f-df f-ai">
            <el-date-picker
              v-model="bindForms[item.startTimeId]"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :format="item.format || 'yyyy年 MM月 dd日'"
              :value-format="item.valueFormat || 'yyyy-MM-dd'"
              :type="item.dateType"
              :clearable="!item.clearable"
              @change="formChange($event, item, 'datesRangeStart')" />
              <span class="pd-row10">至</span>
            <el-date-picker
              v-model="bindForms[item.endTimeId]"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :format="item.format || 'yyyy年 MM月 dd日'"
              :value-format="item.valueFormat || 'yyyy-MM-dd'"
              :type="item.dateType"
              :clearable="!item.clearable"
              @change="formChange($event, item, 'datesRangeEnd')" />
          </div>
          <!-- 日期选择 -->
          <el-date-picker
            v-else-if="item.type === 'datetimerange'"
            v-model="bindForms[item.id]"
            :clearable="!item.clearable"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :format="item.format || 'yyyy年 MM月 dd日'"
            :value-format="item.valueFormat || 'yyyy-MM-dd'"
            @change="formChange($event, item)" />
          <!-- 树形 -->
          <el-cascader
            v-else-if="item.type === 'tree'"
            v-model="bindForms[item.id]"
            :options="item.children"
            :props="item.props || props"
            :clearable="!!item.clearable"
            :filterable="!!item.filterable"
            :separator="item.separator || ' - '"
            :placeholder="item.placeholder || '请选择'"
            @change="formChange($event, item)" />
          <!-- input框 -->
          <el-input
            v-else-if="item.type === 'input'"
            v-model="bindForms[item.id]"
            :type="item.visibleType || 'text'"
            :clearable="!item.clearable"
            :disabled="item.noInsert && pageType === 'edit'"
            :placeholder="item.placeholder || '请输入'"
            :rows="3"
            autocomplete="off"
            @change="formChange($event, item)"
            @keyup.enter.native="inpKeyEnter($event, item)">
            <i
              v-if="item.inpType === 'password' && item.visibleType === 'text' && item.isVisible"
              slot="suffix"
              class="f-fs16 iconfont icon-mimakejian cursor-pointer"
              @click="toggleShow(item)"
            ></i>
            <i
              v-if="item.inpType === 'password' && item.visibleType === 'password' && !item.isVisible"
              slot="suffix"
              class="iconfont icon-mimabukejian cursor-pointer"
              @click="toggleShow(item)"
            ></i>
          </el-input>
          <p v-if="item.tipTxt" class="form-item-tips f-fs1 color-gray-76 mg-top5">{{ item.tipTxt }}</p>
        </el-form-item>
      </el-form>
    </div>
    <slot></slot>
    <!--按钮查询重置-->
    <div v-if="isGroupBtn && formArr.length" class="filter-group-btn pd15 f-df f-jcsb f-ai">
      <el-form>
        <el-form-item>
          <el-button type="primary" size="small" @click="filterCheckBtn">{{ ensurnBtnTxt }}</el-button>
          <el-button size="small" plain class="reset-btn" @click="filterResetBtn">{{ cancelBtnTxt }}</el-button>
        </el-form-item>
      </el-form>
      <!-- 展开 / 收起 -->
      <div v-if="isShowFilterExpand" class="icon-expand-box f-csp pd-right15" @click="isExpand = !isExpand">
        <span class="color-blue mg-right5">{{ isExpand ? '收起' : '展开' }}</span>
        <i :class="isExpand ? 'icon-expand' : 'icon-downup'"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'formBindValue',
    event: 'change'
  },
  props: {
    pageType: {
      type: String,
      default: ''
    },
    addBtnTxt: {
      type: String,
      default: '新增'
    },
    ensurnBtnTxt: {
      type: String,
      default: '确定'
    },
    cancelBtnTxt: {
      type: String,
      default: '取消'
    },
    isGroupBtn: {
      type: Boolean,
      default: false
    },
    isShowFilterExpand: {
      type: Boolean,
      default: false
    },
    isAddBtn: {
      type: Boolean,
      default: false
    },
    isShowChooseFilter: {
      type: Boolean,
      default: false
    },
    formArr: {
      type: Array,
      default: () => {
        return []
      }
    },
    formRules: {
      type: Object,
      default: () => {
        return {}
      }
    },
    formBindValue: {
      type: Object,
      default: () => {
        return {}
      }
    },
    formItemPosition: {
      type: String,
      default: 'row' // 默认表单元素布局是行展示：垂直：vertical，行展示：row
    },
    lablePosition: {
      type: String,
      default: 'right' // right/left/top
    },
    labelWidth: {
      type: String,
      default: '80px'
    }
  },
  data() {
    return {
      bindForms: {},
      props: {
        value: 'id',
        label: 'name',
        expandTrigger: 'hover',
        multiple: true,
        max: 2
      },
      isExpand: true,
      ruleForm: {}
      // props: {
      //   value: 'id',
      //   label: 'name',
      //   checkStrictly: true,
      //   expandTrigger: 'hover',
      //   multiple: true,
      //   lazy: true,
      //   lazyLoad: (node, resolve) => {
      //     this.loadNode(node, resolve)
      //   }
      // }
    }
  },
  computed: {
    chooseFilterArr() {
      const arr = []
      for (const key in this.bindForms) {
        const targeObj = this.formArr.find(item => item.id === key) || ''
        const id = this.bindForms[key]
        const value = this.getFilterTxtByKey(id, key)
        if (id && value) {
          arr.push({
            label: targeObj.label || '',
            key: key,
            id: id,
            value: value
          })
        }
      }
      return arr
    }
  },
  watch: {
    formBindValue: {
      handler(newArr, oldArr) {
        this.bindForms = newArr
      },
      deep: true,
      immediate: true
    },
    formRules: {
      handler(newArr, oldArr) {
        // 密码验证
        const validatePass = (rule, value, callback) => {
          if (value === '') {
            callback(new Error('请输入密码'))
          } else {
            if (this.bindForms.checkPass !== '') {
              this.$refs.ruleForm.validateField('checkPass')
            }
            callback()
          }
        }
        // 密码再次验证
        const validatePass2 = (rule, value, callback) => {
          if (value === '') {
            callback(new Error('请再次输入密码'))
          } else if (value !== this.bindForms.password) {
            callback(new Error('两次输入密码不一致!'))
          } else {
            callback()
          }
        }
        // 自定义规则
        const rules = [
          {
            validateType: 'password',
            rule: [{ validator: validatePass, trigger: 'blur' }]
          },
          {
            validateType: 'checkPass',
            rule: [{ validator: validatePass2, trigger: 'blur' }]
          }
        ]
        const ruleForm = {}
        // 正则表达式验证
        for (const key in this.formRules) {
          ruleForm[key] = []
          ruleForm[key] = this.formRules[key].map(item => {
            let regItem = item
            if (item.pattern) {
              // 账号正则表达式检查
              const checkReg = (rule, value, callback) => {
                // 定义验证正则表达式
                let reg = item.pattern
                if (typeof reg === 'string') {
                  reg = this.$util.evil(reg)
                }
                // 合法： regMobile.test(value)进过测试后放回的值
                if (!value || reg.test(value)) {
                  callback()
                } else {
                  // 不合法
                  callback(new Error(item.message || '不符合规则'))
                }
              }
              regItem = { validator: checkReg, trigger: item.trigger || 'blur' }
            }
            return regItem
          })
        }
        if (ruleForm) {
          this.formArr.forEach(item => {
            // 如果存在手机号码验证，则添加
            const ruleItem = rules.find(elem => elem.validateType === item.validateType)
            if (ruleItem) {
              if (ruleForm[item.id]) {
                ruleForm[item.id] = ruleForm[item.id].concat(ruleItem.rule)
              } else {
                ruleForm[item.id] = ruleItem.rule
              }
            }
          })
        }
        this.ruleForm = ruleForm
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 树形
    loadNode(node, resolve) {
      if (node.data.leaf || node.data.children) {
        resolve([])
        return
      }
      this.$emit('treeLoadNode', node, data => {
        resolve(data)
      })
    },
    // 密码可见
    toggleShow(item) {
      item.isVisible = !item.isVisible
      item.visibleType = item.isVisible ? 'text' : 'password'
    },
    // input类型enter触发操作
    inpKeyEnter($event, item) {
      this.formChange(this.bindForms[item.id], item)
    },
    // 点击tab类型时
    tabGropChange(item, elem) {
      this.bindForms[item.id] = elem.id
      this.$emit('changeFormBind', this.bindForms, item, elem.id)
    },
    // 新增按钮
    addBtn() {
      this.$emit('addBtn')
    },
    // 查询按钮
    filterCheckBtn() {
      // 检查填写是否合格
      this.$refs.ruleForm.validate((valid) => {
        console.log(valid)
        if (valid) {
          this.$emit('change', this.bindForms)
          this.$emit('filterCheckBtn')
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 重置按钮
    filterResetBtn() {
      const bindForms = this.formArr.reduce((obj, item) => {
        obj[item.id] = ''
        return obj
      }, {})
      this.bindForms = Object.assign(this.bindForms, bindForms)
      this.$emit('change', this.bindForms)
      this.$emit('filterResetBtn')
    },
    // 根据key获取对应文本text
    getFilterTxtByKey(value, key) {
      const obj = this.formArr.find(item => item.id === key)
      if (obj.type === 'input') {
        return value
      }
      if (obj && obj.children && obj.children.length) {
        if (obj.type === 'tree') {
          // 树形结构的文字转化
          let chooseTxt = ''
          // let arr = obj.children
          if (value && value.length) {
            chooseTxt = value.join(' - ')
            // value.forEach(item => {
            //   const findObj = this.findTreeTxt(item, arr)
            //   arr = findObj.children
            //   if (findObj) chooseTxt += findObj.name + '-'
            // })
            // if (chooseTxt) chooseTxt = chooseTxt.substr(0, chooseTxt.length - 1)
          }
          return chooseTxt
        } else if (obj.type === 'checkbox') {
          let chooseTxt = ''
          if (value && value.length) {
            chooseTxt = value.reduce((preStr, valueId) => {
              const findObj = obj.children.find(elem => elem.id + '' === valueId + '')
              if (findObj) preStr += findObj.name + ','
              return preStr
            }, '')
            if (chooseTxt) chooseTxt = chooseTxt.substr(0, chooseTxt.length - 1)
          }
          return chooseTxt
        } else if (obj.type === 'radio' || obj.type === 'select' || obj.type === 'radioDate') {
          // 单选value转文字展示
          const currentObj = obj.children.find(item => item.id + '' === value + '')
          return currentObj ? currentObj.name : value
        }
      }
    },
    // 删除选择条件
    deleteFilter(value, key) {
      this.bindForms[key] = typeof value !== 'object' ? '' : []
      const obj = this.formArr.find(item => item.id === key)
      this.$emit('changeFormBind', this.bindForms, obj, '')
    },
    // 选择改变时触发
    formChange($event, item) {
      // 点击的是自定义
      if (item.type === 'radioDate') {
        const dateItem = item.children.find(elem => elem.id === $event)
        this.dateDefineChoose(item, dateItem)
        if (dateItem.name.indexOf('自定义') >= 0) return
      }
      this.$emit('changeFormBind', this.bindForms, item, $event)
    },
    // 自定义时间点击按钮
    dateDefineChoose(item, elem) {
      item.isShowChooseDate = elem.name.indexOf('自定义') >= 0
      if (item.isShowChooseDate) {
        elem.name = '自定义'
      } else {
        item.defineDateVal = ''
      }
    },
    // 自定义时间确定按钮
    defineDateEnsure(value, item) {
      const i = item.children.findIndex(item => item.name.indexOf('自定义') >= 0)
      const defineItem = item.children[i]
      const dateVal = value.length ? value.join(' 至 ') : value
      defineItem.id = dateVal
      defineItem.name = '自定义：' + dateVal
      this.$set(item.children, i, defineItem)
      // 修改当前时间
      this.bindForms[item.id] = dateVal
      // this.formChange(value, item, true)
      this.$emit('changeFormBind', this.bindForms, item, value)
      item.isShowChooseDate = false
    },
    // 自定义日期取消
    defineDateCancle(item) {
      item.isShowChooseDate = false
      item.defineDateVal = ''
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/less/color.less';
.icon-mimakejian,
.icon-mimabukejian{
  font-size: 24px;
}
.list-fliter-wrap{
  & .tab-group{
    & ul{
      border-radius: 3px;
    }
    & li{
      padding: 0px 20px;
      &:first-child{
        border-top-left-radius: 3px;
        border-bottom-left-radius: 3px;
      }
      &:last-child{
        border-top-right-radius: 3px;
        border-bottom-right-radius: 3px;
      }
    }
  }
  & .list-fliter-main-con{
    min-width: 1100px;
    max-width: 1500px;
  }
  & .radio-date-define-box{
    height: 34px;
    & .radio-date-range{
      width: 450px;
      & .cancle-date-btn,
      & .ensure-date-btn{
        width: 60px;
        text-align: center;
      }
      & .ensure-date-btn{
        height: 23px;
        line-height: 22px;
        padding: 0 8px;
        border-radius: 3px;
      }
    }
  }
  & .add-item-btn{
    right: 30px;
    top: 15px;
  }
  & .filter-group-btn{
    width: 100%;
    & .reset-btn{margin-left: 20px!important;}
  }
  // 已选条件
  .selete-filter-item-box{
    margin-bottom: 15px;
    padding: 0 15px 0 12px;
    .selected-item{
      padding: 2px 10px;
      border-radius: 3px;
    }
  }
  // 展开收起图标
  & .icon-expand-box{
    & .icon-expand::after,
    & .icon-expand::before,
    & .icon-downup::after,
    & .icon-downup::before{
      content: "";
      position: absolute;
      width: 6px;
      height: 6px;
      border-left: 1px solid @color-blue;
    }
    & .icon-expand::after,
    & .icon-expand::before{
      border-top: 1px solid @color-blue;
      transform: rotate(45deg);
    }
    & .icon-expand::before{ margin-top: 6px; }
    & .icon-expand::after{ margin-top: 11px; }
    & .icon-downup::after,
    & .icon-downup::before{
      border-bottom: 1px solid @color-blue;
      transform: rotate(-45deg);
    }
    & .icon-downup::before{ margin-top: 2px; }
    & .icon-downup::after{ margin-top: 7px; }
  }
}
/deep/ .el-form .el-form-item:last-child{
  margin-right: 0;
}
/deep/ .form-item-pass-box,.form-item-checkPass-box{
  & .el-input__prefix, .el-input__suffix{
    display: flex;
  }
}
</style>
